import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import "./ImpersonationBanner.css";

import { User } from "pwapi";

import { logout } from "shared/actions/authActions";
import { wipeCaseDetail } from "shared/actions/caseDetailActions";
import { wipeCases } from "shared/actions/casesActions";
import { wipeSlideDetail } from "shared/actions/slideDetailActions";

import ImpersonationLogOutButton from "components/ImpersonationLogOutButton";
import ApplicationState from "store/ApplicationState";
import { AppDispatch } from "store/store";

const ImpersonationBanner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const logoutParam = queryParams.get("logout");

  const user: User | undefined = useSelector(
    ({ auth }: ApplicationState) => auth.user
  );
  const hasImpersonator: boolean = useSelector(
    ({ auth }: ApplicationState) => !!auth.access?.impersonator_id
  );
  const dispatch = useDispatch<AppDispatch>();

  const logoutUser = () => {
    dispatch(logout());
    dispatch(wipeCases());
    dispatch(wipeCaseDetail());
    dispatch(wipeSlideDetail());
    navigate("/");
  };

  // Since Django-hijack only releases the impersonated user in the context of the Django admin,
  // we need to log out the current user as well to ensure the auth state in redux is refreshed.
  useEffect(() => {
    if (logoutParam) {
      logoutUser();
    }
  }, [logoutParam]);

  if (!hasImpersonator || !user) {
    return null;
  }

  return (
    <header className="impersonation-banner alert-warning">
      <div className="impersonation-banner__left">
        You are impersonating
        <strong>
          {" "}
          {user.first_name || user.last_name ? (
            <span>
              {user.first_name}&nbsp;{user.last_name}
            </span>
          ) : (
            <span>{user.username}</span>
          )}{" "}
        </strong>
      </div>
      <ImpersonationLogOutButton />
    </header>
  );
};

export default ImpersonationBanner;
